import * as types from "../actionTypes";

export const showWarning = data => {
  return {
    type: types.CHANGE_ACCESS_DENIED_SHOW_WARNING,
    data
  };
};
export const closeWarning = () => {
  return {
    type: types.CHANGE_ACCESS_DENIED_CLOSE_WARNING
  };
};
